module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-ar-SA.57d94f90.jpg";